import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";
import ReactTost from "../../ReactTost";
import { logout } from "../../../redux/adminUser";
import axios from "axios";
import logoImage from "../../Assets/images/dignity_logo_svg.png";
import { useTranslation } from "react-i18next";

const Header = () => {
  let location = useLocation();
  const isActive = (pathname) => location.pathname.startsWith(pathname);

  const user = localStorage.getItem("id");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;

  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const { t } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);

  function UserLogout(e) {
    e.preventDefault();
    dispatch(logout());
    localStorage.clear();
    navigate("/login");
  }

  function chatbot() {
    axios
      .get(`${API_URL}/${API_VERSION}/bot/user/${user}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((botResponse) => {
        // setBotList(botResponse.data);

        if (botResponse.data.length > 0) {
          const firstBotId = botResponse.data[0].id;
          localStorage.setItem("firstBot", firstBotId);
          navigate(`/my-bots/${firstBotId}`);
        } else {
          navigate("/my-bots");
        }
      })
      .catch((botError) => {
        setType("Danger");
        setMessage(t("Something went wrong while fetching bot list."));
        setShowAlert(true);
      });
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 991) {
        if (window.scrollY > 100) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />

      <div id="header" className={`logo-back ${isSticky ? "sticky" : ""}`}>
        <Container>
          <Navbar expand="lg">
            <Container fluid>
              <Link className="brand-logo" to={process.env.REACT_APP_URL}>
                <img src={logoImage} alt="" width={100} />
              </Link>
              <Navbar.Toggle aria-controls="navbarScroll">
                <i className="fa-solid fa-bars-staggered"></i>
              </Navbar.Toggle>
              <Navbar.Collapse id="navbarScroll">
                <Nav className="ms-auto my-2 my-lg-0" navbarScroll>
                  <Link
                    className={`nav-link text-light ${isActive("/my-bots") ? "active-link" : ""}`}
                    to={"/my-bots"}
                    onClick={() => chatbot()}
                  > {t("My Chatbots")}{" "}
                  </Link>
                  <Link 
                    className={`nav-link text-light ${isActive("/my-profile") ? "active-link" : ""}`}
                    to="/my-profile"
                  >{t("My Profile")}
                  </Link>
                  
                  <Link
                    className={`nav-link text-light ${isActive("/changePassword") ? "active-link" : ""}`}
                    to="/changePassword"
                  >{t("Change Password")}
                  </Link>
                  <Link
                    className="nav-link text-light d-inline-block d-lg-none"
                    onClick={(e) => UserLogout(e)}
                  >{t("Logout")}
                  </Link>
                </Nav>
                <Nav
                  className="my-2 my-lg-0 ms-3 d-lg-flex gap-2 d-none"
                  navbarScroll
                >
                  <button className="userbutton" onClick={(e) => UserLogout(e)}>
                    {" "}
                    {t("Logout")}
                  </button>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Container>
      </div>
    </>
  );
};

export default Header;
